import React from "react";
import { Sparkles } from "lucide-react";
import { EVENT_CONFIRMATION_DEFAULTS } from "../../utils/eventConfirmationCopy";
import "./EventConfirmationFields.css";

const EventConfirmationFields = ({
  pretitle,
  title,
  text,
  onPretitleChange,
  onTitleChange,
  onTextChange,
}) => (
  <section className="event-confirmation-fields" aria-labelledby="event-confirmation-fields-title">
    <header className="event-confirmation-fields__header">
      <span className="event-confirmation-fields__icon" aria-hidden="true">
        <Sparkles size={18} strokeWidth={1.8} />
      </span>
      <div>
        <span className="event-confirmation-fields__kicker">POP-UP DUPĂ ÎNSCRIERE</span>
        <h3 id="event-confirmation-fields-title">Mesaj de confirmare</h3>
        <p>Personalizează separat textele afișate după trimiterea formularului.</p>
      </div>
    </header>

    <div className="event-confirmation-fields__grid">
      <label className="event-confirmation-fields__field event-confirmation-fields__field--pretitle">
        <span>Pretitlu</span>
        <input
          type="text"
          name="confirmationPretitle"
          value={pretitle}
          onChange={(event) => onPretitleChange(event.target.value)}
          placeholder={EVENT_CONFIRMATION_DEFAULTS.pretitle}
          maxLength={80}
        />
      </label>

      <label className="event-confirmation-fields__field event-confirmation-fields__field--title">
        <span>Titlu</span>
        <input
          type="text"
          name="confirmationTitle"
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          placeholder={EVENT_CONFIRMATION_DEFAULTS.title}
          maxLength={140}
        />
      </label>

      <label className="event-confirmation-fields__field event-confirmation-fields__field--text">
        <span>Text</span>
        <textarea
          name="confirmationText"
          value={text}
          onChange={(event) => onTextChange(event.target.value)}
          placeholder={EVENT_CONFIRMATION_DEFAULTS.text}
          rows={3}
          maxLength={320}
        />
      </label>
    </div>

    <div className="event-confirmation-fields__preview" aria-label="Previzualizare mesaj de confirmare">
      <span>{pretitle || EVENT_CONFIRMATION_DEFAULTS.pretitle}</span>
      <h4>{title || EVENT_CONFIRMATION_DEFAULTS.title}</h4>
      <p>{text || EVENT_CONFIRMATION_DEFAULTS.text}</p>
    </div>
  </section>
);

export default EventConfirmationFields;
